import { all, call, ForkEffect, put, select, StrictEffect, takeEvery } from 'redux-saga/effects'

import { loadProjectBuildings } from '../../../api/projects-api'
import { updateDocumentMapping } from '../../../api/takeoff-api'
import { DocumentMapping } from '../../../models/documentMapping'
import { Project } from '../../../models/project'
import { Building } from '../../../models/projectBuilding'
import { setBuildings } from '../../slices/buildings'
import { moveChunksToBuilding, selectDocumentMappings } from '../../slices/documents'
import { selectProject } from '../../slices/project'
import { hardUpdateProjectOpeningGroupsAndLocations } from '../2D/hardUpdateProjectOpeningGroups'
import { updateDocumentMappingDataToConformToAPI } from '../2D/updateSingleDocumentMapping'

export function* handleMoveChunksToBuilding(
    action: ReturnType<typeof moveChunksToBuilding>
): Generator<StrictEffect, void, Project & DocumentMapping[] & Building[]> {
    try {
        const project = yield select(selectProject)
        const mappings = yield select(selectDocumentMappings)

        const mappingToUpdate = mappings.filter((mapping) =>
            action.payload.updatedDocumentChunks.find((dc) => dc.id === mapping.document_chunk_id)
        )

        yield all(
            mappingToUpdate.map((updatedMapping) =>
                call(updateDocumentMapping, project.id, updateDocumentMappingDataToConformToAPI(updatedMapping))
            )
        )
        yield call(hardUpdateProjectOpeningGroupsAndLocations, project.id)

        // BE prunes / migrates wall_sheathing_size_<floor> for both source and target buildings
        // inside the UpdateDocumentMapping transaction; refetch so the store stays in sync.
        const refreshedBuildings: Building[] = yield call(loadProjectBuildings, project.id)

        yield put(setBuildings({ buildings: refreshedBuildings }))
    } catch (error) {
        yield call(console.error, error)
    }
}

export function* watchForMoveChunksToBuilding(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(moveChunksToBuilding.type, handleMoveChunksToBuilding)
}
